import { render, staticRenderFns } from "./AccountsAging.vue?vue&type=template&id=62f9e176&scoped=true"
import script from "./AccountsAging.vue?vue&type=script&lang=ts"
export * from "./AccountsAging.vue?vue&type=script&lang=ts"
import style0 from "./AccountsAging.vue?vue&type=style&index=0&id=62f9e176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f9e176",
  null
  
)

export default component.exports